export type ResumenAccountKind =
  | "client_company"
  | "client_person"
  | "jobboard_worker"
  | "other_company"
  | "other_person";

export function getResumenAccountKind(
  userData: { rols?: { name?: string }[]; type?: string | null } | null | undefined
): ResumenAccountKind {
  if (!userData) return "other_person";
  const hasClient = userData.rols?.some((r) => r?.name === "CLIENT") ?? false;
  if (hasClient) {
    return userData.type === "COMPANY" ? "client_company" : "client_person";
  }
  const hasJobboard = userData.rols?.some((r) => r?.name === "JOBBOARD") ?? false;
  if (hasJobboard) {
    return "jobboard_worker";
  }
  return userData.type === "COMPANY" ? "other_company" : "other_person";
}

export function userHasJobboardRole(
  userData: { rols?: { name?: string }[] } | null | undefined
): boolean {
  return userData?.rols?.some((r) => r?.name === "JOBBOARD") ?? false;
}

export function userHasClientRole(
  userData: { rols?: { name?: string }[] } | null | undefined
): boolean {
  return userData?.rols?.some((r) => r?.name === "CLIENT") ?? false;
}

export function userIsJobboardOnlyAccount(
  userData: { rols?: { name?: string }[] } | null | undefined
): boolean {
  return userHasJobboardRole(userData) && !userHasClientRole(userData);
}

export function isExistingClientWithoutJobboardRole(
  userData: { rols?: { name?: string }[] } | null | undefined
): boolean {
  if (!userData?.rols?.length) return false;
  const hasClient = userData.rols.some((r) => r?.name === "CLIENT");
  const hasJobboard = userData.rols.some((r) => r?.name === "JOBBOARD");
  return hasClient && !hasJobboard;
}

export function shouldShowJobboardUpgradePrompt(
  userData: { rols?: { name?: string }[] } | null | undefined
): boolean {
  if (!userData) return false;
  return userIsJobboardOnlyAccount(userData);
}

export function jobboardUpgradeShouldTriggerFreeTrialActivation(
  userData: { free_trial?: { status?: string } } | null | undefined
): boolean {
  return userData?.free_trial?.status === "no-activated";
}

export function userNeedsJobBoardProfileCompletion(
  userData:
    | {
        rols?: { name?: string }[];
        type?: string | null;
        phone?: string | null;
        skills?: { skill?: { id?: string | number; name?: string | null } }[];
      }
    | null
    | undefined
): boolean {
  if (!userData?.rols?.length) return false;
  if (userHasClientRole(userData)) return false;
  const isJobBoard = userData.rols.some((r) => r?.name === "JOBBOARD");
  if (!isJobBoard) return false;

  const hasValidPhone = Boolean((userData.phone ?? "").toString().trim());
  const hasValidSkills =
    (userData.skills ?? [])
      .map((s) => ({
        id: Number(s?.skill?.id),
        name: String(s?.skill?.name ?? ""),
      }))
      .filter((s) => !Number.isNaN(s.id) && Boolean(s.name)).length > 0;

  return userData.type == null || !hasValidPhone || !hasValidSkills;
}
